import { useState, useEffect, createContext } from "react";
import { AxiosResponse } from "axios";
import {
  typeCountryDto,
  typeApiResponse,
  iTypeRegion,
  countryDataTypes,
  regionDataTypes,
  countryRegionContextType,
} from "../../utils/typeDefs";
import { apiUrls } from "../../utils/apiUrls";
import { getData } from "../../utils/reusables";

type regionProps = {
  children: JSX.Element;
};

const CountryRegionContext = createContext<countryRegionContextType | null>(
  null
);

const CountryRegionContextProvider = ({ children }: regionProps) => {
  const [countryData, setCountryData] = useState<typeCountryDto[] | []>([]);
  const [regionData, setRegionData] = useState<iTypeRegion[]>([]);

  useEffect(() => {
    getData(apiUrls.country.base).then(
      (result: AxiosResponse<countryDataTypes & typeApiResponse>) =>
        setCountryData(
          result.data.data.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
          )
        )
    );
    getData(apiUrls.country.getRegions).then(
      (result: AxiosResponse<regionDataTypes & typeApiResponse>) =>
        setRegionData(result.data.data)
    );
  }, []);

  return (
    <CountryRegionContext.Provider
      value={{
        regionData,
        countryData,
      }}
    >
      {children}
    </CountryRegionContext.Provider>
  );
};

export { CountryRegionContextProvider, CountryRegionContext };
